import { CssBaseline, Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { FunctionComponent } from 'react';
import { I18nextProvider } from 'react-i18next';

import FullScreenLoader from '@Components/FullScreenLoader';
import GlobalErrorAlert from '@Containers/GlobalErrorAlert';
import getMaterialTheme from '@Theme/theme';
import useAuthStatus from '@Utils/hooks/useAuthStatus.hook';

import i18n from './i18n';
import AppRoutes from './Routes';

import './styles/index.scss';

const theme = getMaterialTheme();

const App: FunctionComponent = () => {
  const { isLoading } = useAuthStatus();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <I18nextProvider i18n={i18n}>
        {!isLoading ? (
          <AppRoutes />
        ) : (
          <Box height="100vh">
            <FullScreenLoader />
          </Box>
        )}
        <GlobalErrorAlert />
      </I18nextProvider>
    </ThemeProvider>
  );
};

export default App;
